<app-page-header title="Home" titleLink="/reports" active_item="Infrações">
</app-page-header>

<form [formGroup]="extrato">
  <div class="row">
    <h5>{{ "common.infractions" | translate }}</h5>

    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"></i
            ></a>
          </div>
        </div>

        <div class="card-body filter-extrato" [(ngbCollapse)]="isFilterColapsed">
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTransactionType" class="form-label">{{ "common.type" | translate }}</label>

                <ng-select
                  id="slTransactionType"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="transactionTypes"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.tipo"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slStatus" class="form-label">{{ "common.status" | translate }}</label>

                <ng-select
                  id="slStatus"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="statusList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.status"
                >
                </ng-select>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.initialDate" | translate }}
                </label>

                <mat-form-field appearance="fill" class="w-100 date-align custom-datetime">
                  <input
                    #startText
                    matInput
                    [matDatepicker]="pickerIni"
                    placeholder="DD/MM/YYYY"
                    [formControl]="extrato.controls.initialDate"
                    (input)="startRaw = startText.value"
                    (dateChange)="startRaw = startText.value"
                    (blur)="parseDateInput('initialDate', startRaw)"
                    (keydown.enter)="parseDateInput('initialDate', startRaw)"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickerIni"></mat-datepicker-toggle>
                  <mat-datepicker #pickerIni startView="month"></mat-datepicker>
                </mat-form-field>

                <div class="invalid-feedback d-block" *ngIf="extrato.controls.initialDate.invalid && isSubmitted">
                  {{ "common.initialDateRequired" | translate }}
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputFinalDate" class="form-label">
                  {{ "common.finalDate" | translate }}
                </label>

                <mat-form-field appearance="fill" class="w-100 date-align custom-datetime">
                  <input
                    #endText
                    matInput
                    [matDatepicker]="pickerFim"
                    placeholder="DD/MM/YYYY"
                    [formControl]="extrato.controls.endDate"
                    (input)="endRaw = endText.value"
                    (dateChange)="endRaw = endText.value"
                    (blur)="parseDateInput('endDate', endRaw)"
                    (keydown.enter)="parseDateInput('endDate', endRaw)"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                  <mat-datepicker #pickerFim startView="month"></mat-datepicker>
                </mat-form-field>

                <div class="invalid-feedback d-block" *ngIf="extrato.controls.endDate.invalid && isSubmitted">
                  {{ "common.finalDateRequired" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTipoBusca" class="form-label">{{ "common.searchType" | translate }}</label>

                <ng-select
                  id="slTipoBusca"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="tipoBuscaList"
                  bindValue="value"
                  bindLabel="name"
                  [formControl]="extrato.controls.tipoBusca"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDescricao" class="form-label">{{ "common.search" | translate }}</label>

                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    name="descricao"
                    id="txtDescricao"
                    bindValue="value"
                    [formControl]="extrato.controls.responsavel"
                  />
                  <i class="fe fe-clipboard input-icon btn-color" (click)="paste()"></i>
                </div>
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar(startRaw, endRaw)"
              >
                <i class="fe fe-search me-2"></i>{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>

    <div class="col-md-13 col-xl-13">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{ "common.medpixValues" | translate }}</span>
                  <p class="fs-15 me-3 mb-0">{{ valueMedPix | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{ "common.quantMedpix" | translate }}</span>
                  <p class="fs-15 me-3 mb-0">{{ qtdeMedPix }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-warning-transparent text-warning me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-12 font-weight-500 text-muted me-3">{{ "common.complaintValues" | translate }}</span>
                  <p class="fs-15 me-3 mb-0">{{ valueComplaint | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-warning-transparent text-warning me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-12 font-weight-500 text-muted me-3">{{ "common.quantComplaints" | translate }}</span>
                  <p class="fs-15 me-3 mb-0">{{ qtdeComplaint }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3">
                    <i class="fa fa-caret-up icon-blue"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{ "common.judicialValues" | translate }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ valueJudicial | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span class="avatar avatar-md rounded-3 bg-primary-transparent text-dark me-3">
                    <i class="fa fa-caret-up icon-blue"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{ "common.quantJudicial" | translate }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ qtdeJudicial }}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.infractions" | translate }}
          </div>
          <div class="card-options">
            <button
              type="button"
              class="btn btn-pill btn-default-light"
            >
              <i class="fe fe-download me-2"></i>Exportar Excel
            </button>
          </div>
        </div>
        <div class="card-body button-table">
          <app-table-infractions></app-table-infractions>
        </div>
      </div>
    </div>
  </div>
</form>